import { NavBar } from '@design-system/NavBar';
import { ToggleGroup, ToggleGroupItem } from '@design-system/ToggleGroup';
import { Skeleton } from '@design-system/Skeleton';

export const HealthL4ImproveMyScoreDetailSkeleton = () => {
  return (
    <section className='w-full page-container'>
      <NavBar returnButtonTitle="Health" className="md:-ml-5 mt-8" />
      
      <div className="flex flex-col gap-4 mt-12">
        <Skeleton className="h-12 w-96" />
      </div>

      <div className='mt-6'>
        <ToggleGroup type="single" variant="text">
          <ToggleGroupItem 
            className='px-4 py-2 bg-white h-8 w-20' 
            value="Foods"
            disabled
          >
          </ToggleGroupItem>
          <ToggleGroupItem 
            className='px-4 py-2 bg-white h-8 w-20' 
            value="Ingredients"
            disabled
          >
          </ToggleGroupItem>
        </ToggleGroup>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 mt-12'>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className='w-full h-20 px-6 py-1 pr-5 rounded-md bg-white flex justify-between items-center'
          >
            <div className="flex items-center gap-7">
              <div className="h-16 flex items-center justify-center">
                <Skeleton className="w-10 h-10 rounded-md" />
              </div>

              <div className="flex flex-col gap-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};